var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-spin',{staticClass:"custom-search"},[_c('a-icon',{attrs:{"slot":"indicator","type":"loading"},slot:"indicator"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }